"use strict";
//# sourceMappingURL=types.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@fluentui/react-component-event-listener/dist/commonjs/types.js
// module id = 710
// module chunks = 0